const ENVIRONMENTS = [
    // DEV (LOCAL)
    {
        name: 'dev',
        front: 'localhost',
        path: 'http://immersive-garden-2018.local',
        uploads: 'http://immersive-garden-2018.local/admin_a09ce8cf/storage/uploads',
        api:
        {
            collections: 'http://immersive-garden-2018.local/admin_a09ce8cf/api/collections/get/',
            regions: 'http://immersive-garden-2018.local/admin_a09ce8cf/api/regions/data/'
        }
    },
    // DEV (LOCAL)
    {
        name: 'dev',
        front: 'immersive-garden-2018.local',
        path: 'http://immersive-garden-2018.local',
        uploads: 'http://immersive-garden-2018.local/admin_a09ce8cf/storage/uploads',
        api:
        {
            collections: 'http://immersive-garden-2018.local/admin_a09ce8cf/api/collections/get/',
            regions: 'http://immersive-garden-2018.local/admin_a09ce8cf/api/regions/data/'
        }
    },
    // DEV (Florian)
    {
        name: 'dev',
        front: '192.168.1.97',
        path: 'https://temporary-site.imm-g-prod.com',
        uploads: 'https://temporary-site.imm-g-prod.com/admin_a09ce8cf/storage/uploads',
        api:
        {
            collections: 'https://temporary-site.imm-g-prod.com/admin_a09ce8cf/api/collections/get/',
            regions: 'https://temporary-site.imm-g-prod.com/admin_a09ce8cf/api/regions/data/'
        }
    },
    // STAGING (LOCAL)
    {
        name: 'staging',
        front: 'temporary-site.imm-g-prod',
        path: 'https://temporary-site.imm-g-prod.com',
        uploads: 'https://temporary-site.imm-g-prod.com/admin_a09ce8cf/storage/uploads',
        api:
        {
            collections: 'https://temporary-site.imm-g-prod.com/admin_a09ce8cf/api/collections/get/',
            regions: 'https://temporary-site.imm-g-prod.com/admin_a09ce8cf/api/regions/data/'
        }
    },
    // PROD
    {
        name: 'prod',
        front: 'immersive-g',
        path: 'https://immersive-g.com',
        uploads: 'https://immersive-g.com/admin_a09ce8cf/storage/uploads',
        api:
        {
            collections: 'https://immersive-g.com/admin_a09ce8cf/api/collections/get/',
            regions: 'https://immersive-g.com/admin_a09ce8cf/api/regions/data/'
        }
    }
]

const currentURL = window.location.href.toLowerCase()
const getEnv = url =>
{
    let env = ENVIRONMENTS[ENVIRONMENTS.length - 1]

    for (let i = 0, l = ENVIRONMENTS.length; i < l; i += 1)
    {
        if (url.indexOf(ENVIRONMENTS[i].front) !== -1)
        {
            env = ENVIRONMENTS[i]

            return env
        }
    }

    return env
}

const env = getEnv(currentURL)

export default
{
    env,

    json:
    {
        global: '/static/json/global.json',
        seo: '/static/json/seo.json',
        contact: `${env.api.regions}page_contact?populate=1`,
        cases: `${env.api.collections}cases?populate=1`,
        news: `${env.api.collections}news?populate=1`,
        recognitions: `${env.api.collections}recognitions?populate=1`
    },

    // Please sort the pages alphabetically
    pages:
    {
        home:
        {
            url: '/',
            name: 'page-home',
            meta:
            {
                component: 'page-home',
                name: 'home',
                color: 'black',
                api: {}
            }
        },
        about:
        {
            url: '/about-us',
            name: 'page-about',
            meta:
            {
                component: 'page-about',
                name: 'about',
                color: 'black',
                api:
                {}
            }
        },
        case:
        {
            url: '/cases/:slug',
            name: 'page-case',
            meta:
            {
                component: 'page-case',
                name: 'case',
                color: 'white',
                api: {}
            }
        },
        404:
        {
            url: '*',
            name: 'page-404',
            meta:
            {
                component: 'page-404',
                name: '404',
                api:
                {}
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/config.js